import { useMutation as e } from "@maat/store-hooks";
import { adminAiApi as t } from "@maat/api-ai";
//#region src/ai/admin/useAdminAiGenerateMutation.ts
var n = () => e({ mutationFn: ({ promptType: e, payload: n }) => t.generate(e, n) });
//#endregion
export { n as useAdminAiGenerateMutation };
